import React from 'react';

import { InteractionModalComponentProps } from '$/components/Interactions/types';
import Form from '$/components/ui/Form';
import Input from '$/components/ui/Input/Basics/Input';
import Settings from '$/components/ui/Settings';

const TipWithKoFiSettings: React.FC<InteractionModalComponentProps> = () => {
  return (
    <>
      <Form.FieldLabel title={<div className='flex'>Your Ko-fi username</div>} />
      <Form.Field name='details.username' component={<Input placeholder='Example: d_ewebinar' />} />
      <Settings.Description className='mt-1e'>
        Customize your page and widget on{' '}
        <a href='https://ko-fi.com/settings' target='_blank' rel='noopener'>
          Ko-fi.com
        </a>
        .
      </Settings.Description>
    </>
  );
};

export default TipWithKoFiSettings;
